// Distinct trimmed line item names across the given jobs, sorted for the
// filter dropdown. Derived from the displayed jobs so the options always
// match the jobs on the map, like Jobber's line item filter.
export function collectLineItemNames(jobs = []) {
  const names = new Set();

  for (const job of jobs) {
    for (const item of job?.lineItems || []) {
      const name = item?.name?.trim();
      if (name) names.add(name);
    }
  }

  return [...names].sort((a, b) => a.localeCompare(b));
}
